import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";

const { forwardRef, useImperativeHandle } = React;

const CategoriesSelect = forwardRef(({ oldCategory, onChange, label }, ref) => {
  const [categoryData, setCategoryData] = useState([]);
  const [categoriesOption, setCategoriesOption] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedCategories([]);
      getCategory();
    },
  }));

  const getCategory = async (params) => {
    const path = "admin/categories/withoutPaginate";
    try {
      const response = await getApi({ path, params: { ...params } });
      setCategoryData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    let newCategory = [];

    // categoriesOption.length <= 0 &&
    categoryData?.map((item) =>
      newCategory.push({
        value: item._id,
        label: item.name,
      })
    );
    setCategoriesOption(newCategory);
  }, [categoryData]);

  function handleCategory(data) {
    setSelectedCategories(data);
    const newData = data.map((item) => {
      return item.value;
    });
    onChange(newData || []);
  }

  useEffect(() => {
    if (oldCategory?.length > 0) {
      let selectedCategories = [];
      for (let i = 0; i < oldCategory?.length; i++) {
        let isExist = categoryData.filter((item) => {
          return item._id == oldCategory[i]._id;
        });
        if (!isExist[0]) continue;
        selectedCategories.push({
          value: isExist[0]._id,
          label: isExist[0].name,
        });
      }
      setSelectedCategories(selectedCategories);
    }
  }, [oldCategory, categoryData]);


  return (
    <div>
      {label ? (
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {label}
        </label>
      ) : null}
      <Select
        className=""
        options={categoriesOption}
        placeholder="انتخاب دسته بندی"
        value={selectedCategories}
        onChange={handleCategory}
        isSearchable={true}
        isMulti
              styles={{
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
          menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
        menuPortalTarget={document.body}
      />
    </div>
  );
});

export default CategoriesSelect;
